import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Lightbox from "yet-another-react-lightbox";
// eslint-disable-next-line import/no-unresolved
import "yet-another-react-lightbox/styles.css";
// eslint-disable-next-line import/no-unresolved
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
// eslint-disable-next-line import/no-unresolved
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
// eslint-disable-next-line import/no-unresolved
// import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
// eslint-disable-next-line import/no-unresolved
import Zoom from "yet-another-react-lightbox/plugins/zoom";
// eslint-disable-next-line import/no-unresolved
import "yet-another-react-lightbox/plugins/thumbnails.css";

import AppLayout from '../../layouts/app/AppLayout';
import './custom.scss';
import S3ImageViewerWithFallback from '../../components/awsS3ImageViewer/ImgViewerWithFallback';
// import RichTextViewer from '../../components/rich-text-editor/TextViewer';
import { translateThis } from '../../helpers/language.helper';
import SVGIcons from '../../assets/images/icons/svgIcons';
import RichTextViewer from '../../components/rich-text-editor/TextViewer';




const IndividualInvestments = () => {
    // custom home functions here
    const pageName = "Investments";
    
    const location = useLocation();
    const selectedInvestment = location.state?.serviceElement || {};
    const [index, setIndex] = useState();
    const [selectedPhoto, setSelectedPhoto] = useState([])

    useEffect(() => {
        if (selectedInvestment) {
            setSelectedPhoto(selectedInvestment?.image)
        }
    }, []);

    return (
        <AppLayout
            pageName={pageName}
        >
            <div className="main-content-wrapper individual-article-wrapper f-wrp">
                <div className='article-main-wrp f-wrp'>
                    <div className='article-main-container f-wrp'>
                        <div className='article-main-block f-wrp'>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className='article-list-wrp f-wrp'>
                                        <div className='article-list-box f-wrp'>
                                            <span className='article-img'>
                                                <button className='image-popup-btn' type='button'
                                                    onClick={() => {
                                                        setIndex(1)
                                                    }}>
                                                    <S3ImageViewerWithFallback key={`file-${selectedInvestment.id}`} fileKey={selectedInvestment.image} />
                                                </button>
                                            </span>

                                            {selectedPhoto && <Lightbox
                                                slides={selectedPhoto}
                                                render={{
                                                    slide: ({ slide }) => <S3ImageViewerWithFallback isShowRetry key={`file-${slide.src}`} fileKey={selectedInvestment.image} />,
                                                }}
                                                open={index >= 0}
                                                index={index}
                                                close={() => setIndex(-1)}
                                                plugins={[Fullscreen, Slideshow, Zoom]}
                                                controller={{ closeOnBackdropClick: 'true' }}

                                            />}

                                            <div className='breadcrumb-list-wrp f-wrp'>
                                                <ul>
                                                    <li><Link to={'/'}>{translateThis('Home')} <SVGIcons.ChevronRightIcon /></Link></li>
                                                    <li style={{width: '90px', minWidth: '90px', maxWidth: '90px'}}><Link to={'/investments'}>{translateThis('Investments')} <SVGIcons.ChevronRightIcon /></Link></li>
                                                    <li><span>{selectedInvestment.title}</span></li>
                                                </ul>
                                            </div>
                                            <div className='article-detail-box f-wrp'>
                                                <h4>{selectedInvestment.title}</h4>
                                                <p>{selectedInvestment.shortDescription}</p>
                                                <RichTextViewer richText={selectedInvestment?.description} />   
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default IndividualInvestments;